import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * Infusionsoft Logo component
 *
 * @returns JSX.ELEMENT
 */
export const InfusionsoftLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 100 100" data-testid={dataTestId}>
      <rect width="100" height="100" fill="#515EAA" />
      <path
        fill="#fff"
        d="M25.3,74L25.3,74l-0.1-33.8l34.5,12.4L28.7,71.9l42.9,15.4V56.8l-9.5-3.4l-2.3-0.8l3.4-2.1l11.6,4.2v37.2L25.3,74z M70.6,45.4L63.2,50L25.2,36.4L70.6,8.2V45.4z"
      />
    </svg>
  );
};
